<script lang="ts" setup>
	defineProps<{
		percentage?: number
		progressClass?: string
	}>()
</script>

<template>
	<div>
		<!-- ===========+Progress========== -->
		<div class="h-3 w-full overflow-hidden bg-base-50 rounded-lg justify-start items-center inline-flex">
			<div
				class="h-3 relative bg-base-500 rounded-lg custom-transition-2"
				:class="progressClass"
				:style="`width: ${percentage}%`"
			></div>
		</div>
		<!-- =========/========== -->
	</div>
</template>
